import '../../css/lesson-topic-link.css';

// Read-only chip list for a lesson-list table cell ("Тема"/homework columns
// in Events.jsx and groups/GroupLessonsList.jsx) - reuses the exact chip
// look LessonTopicFlyout.jsx already established (.lesson-topic-chip*,
// lesson-topic-link.css) instead of inventing a new visual style. A lesson
// can carry several topics/exercises, so this always renders a wrapping
// list, never assumes exactly one. `items` is [{id, label, onClick}] -
// each caller resolves its own navigation target (student vs group
// workspace, or the exercise-template editor), this component only renders.
export default function LessonLinkChips({ items, icon: Icon }) {
   if (!items || items.length === 0) {
      return '';
   }
   return (
      <div className='lesson-topic-chip-list' onClick={e => e.stopPropagation()}>
         {items.map(item => (
            <span className='lesson-topic-chip' key={item.id} onClick={item.onClick} title={item.label}>
               <Icon style={{ width: 12, height: 12, flex: 'none' }} />
               <span className='lesson-topic-chip-label'>{item.label}</span>
            </span>
         ))}
      </div>
   );
}
